/**
 * Skills tab copy for /api — plain-language guidance for non-technical users.
 */

export const SKILLS_EXPLAINER =
  "Marketing skills are ready-made playbooks your AI agent follows. Paste one setup command, then ask in plain English. No prompt engineering required."

export const SKILLS_API_CONNECTED_NOTE =
  "API-connected skills pull live Humblytics data (traffic, funnels, tests). Use these when you want answers grounded in your account."

export const SKILLS_CONTEXT_ONLY_NOTE =
  "Context-only skills add marketing expertise (copy, SEO, ads, strategy) without calling your analytics."

export const SKILLS_MCP_NOTE =
  "Skills are the easier on-ramp. For live tools and full control in Claude Code, Cursor, or Codex, connect via MCP above."

type SkillWorkflow = {
  id: string
  prompt: string
  outcome: string
  chain: string[]
}

export const SKILL_WORKFLOWS: SkillWorkflow[] = [
  {
    id: "fix-worst-page",
    prompt: "Find my worst-performing page and fix it",
    outcome: "Spot the leak, audit the page, launch a split test",
    chain: ["CRO Optimizer", "Page CRO", "A/B Test Gen"],
  },
  {
    id: "weekly-report",
    prompt: "Weekly performance report with recommendations",
    outcome: "Summarize funnel health and prioritize what to test next",
    chain: ["Funnel Reporter", "CRO Optimizer"],
  },
  {
    id: "cut-worst-ad",
    prompt: "Cut my worst ad and improve the landing page",
    outcome: "Find wasted spend, diagnose the page, ship a better variant",
    chain: ["Funnel Reporter", "CRO Optimizer", "A/B Test Gen", "Ad Expert"],
  },
]
